/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CompilationErrorFromJSON(json) {
    return CompilationErrorFromJSONTyped(json, false);
}
export function CompilationErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        start: json['start'],
        end: json['end'],
        token: json['token'],
        message: json['message'],
        errInstanceOf: !exists(json, 'errInstanceOf') ? undefined : json['errInstanceOf'],
        errType: json['errType'],
    };
}
export function CompilationErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        start: value.start,
        end: value.end,
        token: value.token,
        message: value.message,
        errInstanceOf: value.errInstanceOf,
        errType: value.errType,
    };
}
